<template>
  <div class='title-section-wrapper'>
    <div class='title-section-background'>
      <div class="container">
        <div class='logo-wrapper'>
          <img src="/assets/logo/brand-logo-white.png" alt="Musichenko — дизайнерський медичний одяг" class='img-fluid logo'>
        </div>
        <div class='title-wrapper'>
          <h1 class='h1-title'>Індивідуальний пошив дизайнерського медичного та корпоративного одягу</h1>
        </div>
        <div class="main-text-wrapper">
          <p class='paragraph'>
            Ми використовуємо лише натуральні якісні тканини, а також допомагаємо знайти унікальний стиль і підхід до кожного клієнта.
            Завдяки індивідуальним замірам і широкому вибору моделей ви отримаєте комфортний і надійний спецодяг, а ми будемо раді вислухати всі ваші побажання та вподобання.
            Ми гарантуємо, що замовивши у нас пошив медичного або корпоративного одягу, ви залишитеся задоволені!
          </p>
        </div>
        <div class='product-list-button'>
          <button class="app-btn app-btn-primary" @click="redirectToProducts()">Перейти до списку товарів</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router.js'

export default {
  name: 'TitleSection',
  methods: {
    redirectToProducts () {
      router.push({ name: 'products' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors.scss';
@import 'src/styles/_sizes.scss';
.title-section-wrapper {
  width: 100%;
  height: calc( 100vh - 60px);
  background:  #ffffff url("/assets/backgrounds/main-bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  .title-section-background {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: $white-color;
    text-align: center;
    background-color: $half-black-color;
    .logo-wrapper {
      .logo {
        border-bottom: 2px solid $primary-color;
        padding-bottom: 15px;
      }
    }
    .title-wrapper {
      margin-top: 10px;
      margin-bottom: 30px;
    }
    .product-list-button {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }
}
@media (max-width: $mobile){
  .title-section-wrapper {
    .title-section-background {
      .logo-wrapper {
        border-bottom: 2px solid $primary-color;
        .logo {
          border-bottom: none;
        }
      }
      .title-wrapper {
        text-align: left;
        margin-bottom: 10px;
      }
      .main-text-wrapper {
        text-align: left;
      }
    }
  }
}
@media (max-height: 650px) {
  .title-section-wrapper {
    height: initial;
    .title-section-background {
      padding: 30px 0;
    }
  }
}
</style>
